import React, { useState } from 'react';
import { Type } from 'lucide-react';
import type { Product } from '../../types/product';
import { BulkApplyButton, BulkFieldRow, bulkInputClass } from './BulkFieldRow';

interface BulkTitleFieldProps {
  onUpdate: (updates: Partial<Product>) => void;
}

export function BulkTitleField({ onUpdate }: BulkTitleFieldProps) {
  const [title, setTitle] = useState('');

  return (
    <BulkFieldRow
      icon={<Type className="w-5 h-5 text-gray-500 shrink-0" />}
      label="商品名を変更"
    >
      <input
        type="text"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        placeholder="商品名を入力"
        className={bulkInputClass}
        maxLength={65}
      />
      <BulkApplyButton
        disabled={!title.trim()}
        onClick={() => {
          if (title.trim()) {
            onUpdate({ title: title.trim() });
            setTitle('');
          }
        }}
      />
    </BulkFieldRow>
  );
}
